import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getTestShortCuts } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchTestShortCuts = (page, pageSize, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getTestShortCuts", page, pageSize, type],
        queryFn: () => getTestShortCuts(page, pageSize, type),
        enabled: !!page || !!pageSize || !!type,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchTestShortCuts;
